function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1-1h16v16H-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7 1H2.3C1.585 1 1 1.585 1 2.3V14l2.6-2.6h9.1c.715 0 1.3-.585 1.3-1.3V2.3c0-.715-.585-1.3-1.3-1.3zm0 9.1H3.6l-1.3 1.3V2.3h10.4v7.8zM4.25 5.55h1.3v1.3h-1.3v-1.3zm2.6 0h1.3v1.3h-1.3v-1.3zm2.6 0h1.3v1.3h-1.3v-1.3z",
  fill: "#54585D",
  fillRule: "nonzero"
}))));